import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import { useUploadDocumentContext } from '@swipejobs/i9-document-validations-react';
import dayjs from 'dayjs';
import React from 'react';
import { UploadProgressEnum } from './I9DocumentUploadV1';
import { cacheTranslations } from '@utils/cache-translations';
import { createTranslationService } from '@services/factories';

const useStyles = makeStyles(() => ({
  wrapper: {
    margin: '24px 0'
  },
  cardWrapper: {
    backgroundColor: '#f1f1f1',
    margin: '16px 0',
    padding: '8px',
    width: '100%',
    justifyContent: 'space-between'
  },
  imageWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    width: 'min-content'
  },
  imagesContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    '& > img': {
      height: '100%',
      width: '100%',
      maxHeight: '180px',
      objectFit: 'contain'
    }
  }
}));

interface FieldValueRowProps {
  label: string;
  value: string;
}

const FieldValueRow = ({ label, value }: FieldValueRowProps) => {
  return (
    <Grid container={true} spacing={2}>
      <Grid item={true} xs={4}>
        <div>{label}</div>
      </Grid>
      <Grid item={true} xs={8}>
        <Typography>{value}</Typography>
      </Grid>
    </Grid>
  );
};

const UploadedDocumentPreview = () => {
  const { savedDocuments } = useUploadDocumentContext();
  const css = useStyles();

  const resources = cacheTranslations(
    createTranslationService(),
    {
      issuingAuthorityInputTitle: 'issuingAuthorityInputTitle',
      documentNumberInputTitle: 'documentNumberInputTitle',
      documentInputTitle: 'documentImageLabels.general_SINGLE'
    },
    'i9DocumentUpload'
  );

  const visibleSummaryOfDocs = savedDocuments.filter((i) =>
    [UploadProgressEnum.DONE, UploadProgressEnum.EDITING].includes(i.progress)
  );

  return (
    <Box className={css.wrapper}>
      {visibleSummaryOfDocs.map((doc) => (
        <Grid className={css.cardWrapper} container={true} spacing={2} key={doc.documentIndex}>
          <Grid item={true} xs={8}>
            <FieldValueRow label={resources.documentInputTitle} value={doc?.document?.title ?? ''} />
            <FieldValueRow label={resources.issuingAuthorityInputTitle} value={doc?.issuingAuthority ?? ''} />
            <FieldValueRow label={resources.documentNumberInputTitle} value={doc.documentNumber} />
            <FieldValueRow
              label='Expiry Date'
              value={doc.documentExpiry ? dayjs(doc.documentExpiry).format('MM/DD/YYYY') : 'N/A'}
            />
          </Grid>
          <Grid className={css.imageWrapper} item={true} xs={4}>
            <Box className={css.imagesContainer}>
              <img src={doc?.base64FileFront ?? ''} alt='' />
            </Box>
            {
              doc?.base64FileBack &&
              <Box className={css.imagesContainer}>
                <img src={doc?.base64FileBack} alt='' />
              </Box>
            }
          </Grid>
        </Grid>
      ))}
    </Box>
  );
};

export default UploadedDocumentPreview;



// WEBPACK FOOTER //
// ./src/screens/review-section2/document-upload/v2/UploadedDocumentPreview.tsx